import React, { useState } from 'react';
import { Briefcase, Coffee, Home, Info, MapPin, Settings, User, UserCheck, UserPlus, Users } from 'react-feather';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import CardPost from '../components/CardPost';
import Footer from '../components/Footer';
import Header from '../components/Header';
import UserMini from '../components/UserMini';
import './Profile.css'

function Profile() {
    const screenStates = {
        POSTS: 'POSTS',
        LOADING: 'LOADING',
        FOLLOWING: 'FOLLOWING',
        FOLLOWERS: 'FOLLOWERS',
    }

    const [screenState, setScreenState] = useState(screenStates.POSTS);
    const [isShowDetail, setIsShowDetail] = useState(false)
    const [isFollowing, setIsFollowing] = useState(false)

    function showDetailSection() {
        setIsShowDetail(!isShowDetail)
    }

    async function follow() {
        setIsFollowing(!isFollowing)
    }

    toast.configure()

    return (
        <div className="profile-container">
            <Header />
            <main>
                <div className="profile-banner" style={{ backgroundImage: 'url("https://i.pinimg.com/originals/0e/7f/66/0e7f665474914ade5e81f54e986a73e1.jpg")' }}>
                    <div className="profile-banner-fade">
                        <div className="button-settings">
                            <a href="/settings">
                                <Settings className="rotate" width="24" height="24" />
                            </a>
                        </div>
                        <div className="profile-info">
                            <div className="profile-detail">
                                <div className="profile-detail-image">
                                    <img src="https://avatarfiles.alphacoders.com/128/128984.png" alt="avatar" />
                                </div>
                                <h3>Matheus José</h3>
                            </div>
                            <div className="profile-stats">
                                <button onClick={() => follow()}>
                                    {isFollowing ? <UserCheck width="30" height="30" />
                                        : <UserPlus width="30" height="30" />
                                    }
                                </button>
                                <div className="stats">
                                    <div className="profile-stats-item">
                                        <h2>5</h2>
                                        <p>Postagens</p>
                                    </div>
                                    <div className="profile-stats-item stats-item-space">
                                        <h2>2</h2>
                                        <p>Seguindo</p>
                                    </div>
                                    <div className="profile-stats-item">
                                        <h2>0</h2>
                                        <p>Seguidores</p>
                                    </div>
                                </div>
                            </div>

                            <button className='button-open-detail-section' type='button' onClick={() => showDetailSection()}>
                                <Info width="24" height="24" />
                                {isShowDetail ? 'fechar detalhes' : 'ver detalhes'}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="profile-content-area">
                    <div className="profile-content-sections">
                        <section className={isShowDetail ? 'active' : ''}>
                            <div className="profile-detail-section">
                                <h3>Biografia</h3>
                                <div className="bio-detail">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ac vulputate diam, et placerat dolor. Curabitur vehicula condimentum odio, sit amet finibus elit vulputate sit amet. Aliquam erat volutpat. Sed ornare mi semper, malesuada mauris quis, dapibus ligula. Nulla mollis dui eget mollis consectetur.</p>
                                </div>
                                <h3>Detalhes</h3>
                                <div className='profile-detail-item'>
                                    <MapPin className='detail-icon' width="20" height="20" />
                                    <p>De Campinas</p>
                                </div>
                                <div className='profile-detail-item'>
                                    <Home className='detail-icon' width="20" height="20" />
                                    <p>Mora em Campinas</p>
                                </div>
                                <div className='profile-detail-item'>
                                    <Briefcase className='detail-icon' width="20" height="20" />
                                    <p>Profissão atual</p>
                                </div>
                                <div className='profile-detail-item'>
                                    <User className='detail-icon' width="20" height="20" />
                                    <p>Masculino</p>
                                </div>
                                <div className='profile-detail-item'>
                                    <Coffee className='detail-icon' width="20" height="20" />
                                    <p>Gosta de café</p>
                                </div>
                            </div>

                        </section>

                        <section>
                            <div className="profile-options-items">
                                <button className={screenState === 'POSTS' ? 'is-selected' : ''} onClick={() => setScreenState(screenStates.POSTS)}>Publicação</button>
                                <button className={screenState === 'FOLLOWING' ? 'is-selected' : ''} onClick={() => setScreenState(screenStates.FOLLOWING)}>Seguindo</button>
                                <button className={screenState === 'FOLLOWERS' ? 'is-selected' : ''} onClick={() => setScreenState(screenStates.FOLLOWERS)}>Seguidores</button>
                            </div>

                            {screenState === 'POSTS' &&
                                <div className="profile-list-posts">
                                    <CardPost
                                        key={12}
                                        user_id={1}
                                        name="Matheus José"
                                        url_avatar="https://avatarfiles.alphacoders.com/128/128984.png"
                                        url_image=""
                                        post_id={12}
                                        text="testando aqui novamente"
                                        visible={1}
                                        created_at="2023-03-24 17:23:10"
                                        liked={false}
                                    />

                                    <CardPost
                                        key={11}
                                        user_id={1}
                                        name="Matheus José"
                                        url_avatar="https://avatarfiles.alphacoders.com/128/128984.png"
                                        url_image=""
                                        post_id={11}
                                        text="Donec maximus congue tellus, at scelerisque sapien maximus quis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Vestibulum eu nulla ligula. Nam elementum vitae magna vel faucibus. Duis luctus semper neque, vel tristique ligula consectetur et. Phasellus vel tellus at velit lacinia laoreet. Nullam vel felis quis eros iaculis malesuada id quis velit. Suspendisse augue arcu, fermentum id sem sed, interdum tincidunt turpis. Vestibulum ac velit mollis, imperdiet odio in, posuere est. Quisque vel turpis lacus. Curabitur gravida nunc a mauris euismod tempus. Sed molestie molestie est, id porttitor odio auctor varius. Donec luctus, est sed eleifend mattis, nibh turpis tincidunt massa, ac dignissim felis mauris vitae tortor. Proin feugiat neque a sapien elementum varius. "
                                        visible={1}
                                        created_at="2023-03-09 16:13:21"
                                        liked={false}
                                    />

                                    <CardPost
                                        key={10}
                                        user_id={1}
                                        name="Matheus José"
                                        url_avatar="https://avatarfiles.alphacoders.com/128/128984.png"
                                        url_image="https://marketplace.canva.com/EAFHzpaWnjU/5/0/1600w/canva-vi…rl-sea-view-city-night-sky-desktop-wallpaper-AgKiUfaluzA.jpg"
                                        post_id={10}
                                        text="testando texto com imagem"
                                        visible={1}
                                        created_at="2023-03-09 15:24:55"
                                        liked={false}
                                    />

                                    <CardPost
                                        key={2}
                                        user_id={1}
                                        name="Matheus José"
                                        url_avatar="https://avatarfiles.alphacoders.com/128/128984.png"
                                        url_image="https://upload.wikimedia.org/wikipedia/commons/2/24/Vista_do_Centro_de_Campinas_SP.JPG"
                                        post_id={2}
                                        text="testando aqui novamente"
                                        visible={1}
                                        created_at="2022-12-11 20:58:47"
                                        liked={false}
                                    />

                                    <CardPost
                                        key={1}
                                        user_id={1}
                                        name="Matheus José"
                                        url_avatar="https://avatarfiles.alphacoders.com/128/128984.png"
                                        url_image=""
                                        post_id={1}
                                        text="testando post"
                                        visible={1}
                                        created_at="2022-12-03 21:41:25"
                                        liked={false}
                                    />
                                </div>
                            }

                            {screenState === 'FOLLOWING' &&
                                <div className="profile-list-users">
                                    <UserMini
                                        id={1}
                                        name="Lucia Campos"
                                        url_avatar=""
                                    />

                                    <UserMini
                                        id={1}
                                        name="João Silva"
                                        url_avatar=""
                                    />
                                </div>
                            }

                            {screenState === 'FOLLOWERS' &&
                                <div className='section-empty'>
                                    <h1><Users width="30" height="30" /> Sem atividade</h1>
                                    <p>Matheus José não tem seguidores ainda.</p>
                                </div>
                            }

                        </section>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    )
}

export default Profile;